import '../styles/main.css';
import Illustration from '../assets/Catalogue-amico.svg';
import {Button} from 'react-materialize';
import { Link } from 'react-router-dom';

export default function login(){
    return(
        <div className='signup-container'>
            <div className='item-one'>
                <img src={Illustration} alt='illustration' className='illustration' />
            </div>
            <div className='item-two'>
                <div className='signup-credentials'>
                    <input type='email' className='email' placeholder='Email'/>
                    <input type='password' className='password' placeholder='password'/>
                </div>
                    <Button
                        style= {{
                            margin:'1rem 0 0 0',
                            marginRight: '5px',
                            background: '#306EFF'
                        }}
                        node="button"
                        waves="#306EFF"
                    >
                        Login
                    </Button>
                    <Link to='/signup' className='new-user'>New User?</Link>
            </div>
        </div>
    )
}
